const styles = {
  main: {
    flex: '1 0 auto',
  },
};

export default styles;
